import { TradeListItem } from 'app/models/trade-list-params'
import { createReducer } from 'app/state/utils'
import * as types from './types'

export interface TradeListState {
  tradeList: TradeListItem[]
  isLoading: boolean
}

const initialState: TradeListState = {
  tradeList: [],
  isLoading: false,
}

/**
 * The Trade List screen's rows, as the server projects them. A READ-only
 * slice: nothing mutates rows in place — a write on a trade goes through the
 * master-trade thunks and the page reloads this list.
 */
const tradeListReducer = createReducer(initialState)({
  [types.GET_TRADE_LIST]: (
    state: TradeListState,
    action: { payload: TradeListItem[] },
  ) => ({ ...state, tradeList: action.payload }),
  [types.START_LOADING_TRADE_LIST]: (state: TradeListState) => ({
    ...state,
    isLoading: true,
  }),
  [types.STOP_LOADING_TRADE_LIST]: (state: TradeListState) => ({
    ...state,
    isLoading: false,
  }),
})

export default tradeListReducer
